
// @ts-nocheck

// [
//     "id",
//     "name",
//     "purposes",
//     "legIntPurposes",
//     "flexiblePurposes",
//     "specialPurposes",
//     "features",
//     "specialFeatures",
//     "cookieMaxAgeSeconds",
//     "usesCookies",
//     "cookieRefresh",
//     "usesNonCookieAccess",
//     "dataRetention",
//     "urls",
//     "dataDeclaration",
//     "deviceStorageDisclosureUrl"
// ]


import { Emit, Component, Prop, Vue, Inject } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';

import ChevronIcon from '../icons/ChevronIcon.vue'
import { Vue3SlideUpDown } from "vue3-slide-up-down";

// import {Vendor} from '@iabtcf/core'

// Vendor type not exported (WTF???) so we have to define it here
interface IntMap<T> {
    [id: string]: T;
}

interface DataRetention {
    stdRetention?: number;
    purposes: IntMap<number>;
    specialPurposes: IntMap<number>;
}

interface VendorUrl {
    langId: string;
    privacy: string;
    legIntClaim: string;
}

type Vendor = {
  id: number;
  name: string;
  purposes: number[];
    legIntPurposes: number[];
    flexiblePurposes: number[];
    specialPurposes: number[];
    features: number[];
    specialFeatures: number[];
    policyUrl?: string;
    usesCookies: boolean;
    cookieMaxAgeSeconds: number | null;
    cookieRefresh: boolean;
    usesNonCookieAccess: boolean;
    deviceStorageDisclosureUrl?: string;
    deletedDate?: Date | string;
    overflow?: {
        httpGetLimit: 32 | 128;
    };
    dataRetention?: DataRetention;
    urls?: VendorUrl[];
    dataDeclaration?: number[];
};



@Component({
  components: {
    ToggleButton,
    ChevronIcon,
    Vue3SlideUpDown
    },
})

export default class VendorListItem extends Vue {

    consent = false;
    legitInterestObjection = false;

    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"
    purposes = [];
    specialPurposes = [];
    features = [];
    specialFeatures = [];
    cookieDuration = "";
    disclosures = [];
    mergedPurposes = [];

    @Prop( { default:{ name:'none', id:0 } }) vendor!: Vendor;

    data() {
      return {
      // disclosures: []
      }
    }


    humanReadableDuration ( seconds : number ) {
      var levels = [
          [Math.floor(seconds / 31536000), 'years'],
          [Math.floor((seconds % 31536000) / 86400), 'days'],
          [Math.floor(((seconds % 31536000) % 86400) / 3600), 'hours'],
          [Math.floor((((seconds % 31536000) % 86400) % 3600) / 60), 'minutes'],
          [(((seconds % 31536000) % 86400) % 3600) % 60, 'seconds'],
      ];
      var returntext = '';

      for (var i = 0, max = levels.length; i < max; i++) {
          if ( levels[i][0] === 0 ) continue;
  //@ts-ignore
          returntext += ' ' + levels[i][0] + ' ' + (levels[i][0] === 1 ? levels[i][1].substr(0, levels[i][1].length-1): levels[i][1]);
      };
      return returntext.trim();
  }


    mounted() : void {

        // console.log( "VendorListItem mounted()");


      if (!this.vendor.policyUrl) {
        this.vendor.policyUrl = "";
        if (this.vendor.urls) {
          for (let i = 0; i < this.vendor.urls.length; i++) {
            if (this.vendor.urls[i].langId == "en") {
              if ( this.vendor.urls[i].privacy )
                this.vendor.policyUrl = this.vendor.urls[i].privacy;
              break;
            }
          }
        }
      }

      if (!this.vendor.legIntClaimUrl) {
        this.vendor.legIntClaimUrl = "";
        if (this.vendor.urls) {
          for (let i = 0; i < this.vendor.urls.length; i++) {
            if (this.vendor.urls[i].langId == "en") {
              if ( this.vendor.urls[i].legIntClaim)
                this.vendor.legIntClaimUrl = this.vendor.urls[i].legIntClaim;
              break;
            }
          }
        }
      }


        this.mergedPurposes = [];

        // if ( this.vendor.purposes ) {
        //   for ( let i =0; i < this.vendor.purposes.length; i ++ ) {
        //      //@ts-ignore
        //     this.mergedPurposes.push( this.vendor.purposes[i] );
        //   }
        // }

        if ( this.vendor.purposes ) {
             //@ts-ignore
             this.mergedPurposes = this.mergedPurposes.concat( this.vendor.purposes );
        }

        if ( this.vendor.legIntPurposes ) {
             //@ts-ignore
             this.mergedPurposes = this.mergedPurposes.concat( this.vendor.legIntPurposes );
        }
        

      //@ts-ignore
      this.cookieDuration = this.humanReadableDuration( this.vendor.cookieMaxAgeSeconds );

      //@ts-ignore
      let model : TCModel = window.__cmpTCModel;

      //@ts-ignore
      this.purposes = window.__GVL.purposes;
      //@ts-ignore
      this.specialPurposes = window.__GVL.specialPurposes;
      //@ts-ignore
      this.features = window.__GVL.features;
      //@ts-ignore
      this.specialFeatures = window.__GVL.specialFeatures;
      this.consent = model.vendorConsents.has( this.vendor.id );

      // console.log( "mounted" );
      // console.log( model );

      this.consent = model.vendorConsents.has( this.vendor.id );
      this.legitInterestObjection = ! model.vendorLegitimateInterests.has( this.vendor.id );
    }
    
     disclosureURLClick() 
    {
      //@ts-ignore
      // console.log ( window.__cmpAPI.getDeviceDisclosures( this.vendor.deviceStorageDisclosureUrl ) ) ;

      let vendorListItem = this;

           //@ts-ignore
      fetch(this.vendor.deviceStorageDisclosureUrl)
      .then(  ( res : any ) => res.json())
      .then( ( out : any ) => {
        let c = out["disclosures"].length;
        
        
        console.log( "Fetched disclosures" );
           //@ts-ignore
       console.log( out["disclosures"] );

        //@ts-ignore
        this.disclosures = [];
        for ( let i =0; i < c; i ++ ) {
          
          let thing = "Data";
           //@ts-ignore
          if ( out["disclosures"][i]["type"] == "cookie" )
            thing = "A browser cookie"
           //@ts-ignore
          else if ( out["disclosures"][i]["type"] == "app" )
            thing = "An app"
           //@ts-ignore
          else if ( out["disclosures"][i]["type"] == "web" )
            thing = "Browser storage"

           //@ts-ignore
          let named = " with identifier " + out["disclosures"][i]["identifier"];

           //@ts-ignore
          let storedAt = out["disclosures"][i]["domain"] ? " for " + out["disclosures"][i]["domain"] : "";

          if ( out["disclosures"][i]["domain"]  == "*" )
            storedAt = " for any domain"

           //@ts-ignore
          let duration = out["disclosures"][i]["maxAgeSeconds"] ? " stored for " + this.humanReadableDuration( out["disclosures"][i]["maxAgeSeconds"] ) : "";

          let desc = thing + named + storedAt + duration + " for the following purposes:" ;


          //@ts-ignore
          this.disclosures.push( { "description":desc, "purposes": out["disclosures"][i]["purposes"] } );

        }

        console.log( "Returned disclosures" );
           //@ts-ignore
       console.log( this.disclosures );

        
      })
      .catch(( err : any ) => { 
        console.log( err ); 
          //@ts-ignore
          this.disclosures.push( { "description": "Error fetching disclosure data from " + this.vendor.deviceStorageDisclosureUrl, "purposes": [] } );  
      });


    }

    @Emit('handleModelChangeEvent')
    changeLegitimateInterest( value: object, srcEvent: any ) {
      // @ts-ignore
      let model = window.__cmpTCModel;
    // @ts-ignore
      if ( value.value )
        model.vendorLegitimateInterests.unset( this.vendor.id );
      else
        model.vendorLegitimateInterests.set( this.vendor.id );

    // @ts-ignore
      this.legitInterestObjection = value.value;

      // TODO: Emit dirty event here to enable button/save
      // this.$emit('modelChangeEvent', true );
    }


    @Emit('handleModelChangeEvent')
    changeConsent( value: object, srcEvent: any ) {
      // @ts-ignore
      let model = window.__cmpTCModel;
    // @ts-ignore
      if ( value.value )
        model.vendorConsents.set( this.vendor.id );
      else
        model.vendorConsents.unset( this.vendor.id );

    // @ts-ignore
      this.consent = value.value;

      // TODO: Emit dirty event here to enable button/save
      // this.$emit('modelChangeEvent', true );
    }

    expandCollapseClick() {
      // console.log("expandCollapseClick()")
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.expanded = ! this.expanded;
    }

}

